import { pipe } from '@helo/utils'

import { Options } from '../../Options'
import { RenderPipeline } from '../../RenderPipeline'
import { ChartDataParts } from '../ChartData/ChartData.parts'
import type { ChartDataLabelSlice } from './ChartDataLabel'
import { chartDataLabelOptions } from './ChartDataLabel.options'

const setDataLabel = () =>
  RenderPipeline.updateOutput(
    (
      _output: { dataLabel?: ChartDataLabelSlice },
      ctx: { input: { showDataLabels?: boolean } },
    ) => ({
      dataLabel: {
        showDataLabels: ctx.input.showDataLabels,
      },
    }),
  )

/** Resolve data-label options from override, then content-node state. */
const setupInput = () =>
  RenderPipeline.updateInput((input, ctx) =>
    pipe(
      input,
      Options.fallback(
        chartDataLabelOptions,
        ChartDataParts.getChartState()(ctx),
      ),
      Options.applyDefaults(chartDataLabelOptions),
      Options.validate(chartDataLabelOptions),
    ),
  )

export const ChartDataLabelInputParts = {
  setupInput,
}

export const ChartDataLabelOutputParts = {
  setDataLabel,
}
